import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';

const Component = lazy(() => import('components/get-started-widget'));

// A floating overlay must not flash a loading placeholder, hence the null fallback.
const GetStartedWidget = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default GetStartedWidget;
